var brands = {
	"STEM Innovator": {
		name: "STEM Innovator",
		title: "STEM Innovator",
		hosts: ["app.steminnovator.com"],
		css: `
			.btn-login {
				background-color: rgb(254, 80, 0);
				color: (255,255,255);
			}
			.text-overlay {
				max-width: 600px;
				bottom: 120px;
				top: 80px;
				left: 10%;
				margin-right: 45px;
			}
			.text-overlay-header {
				color: rgb(254, 80, 0);
			}
			.home-img {
				height: 700px;
			}`,
		header_logo: require("@/assets/images/stem_innovator_logo_trans.png"),
		login_bg: require("@/assets/images/students_sitting.jpg"),
		home_color: "yellow",
		home_promo: true,
		home_title: "STEM INNOVATOR®",
		home_text: "Equip students with critical STEM innovation and entrepreneurship skills. Our research-driven curriculum, instruction, and assessments provide the tools.",
		template: "src/template/inviteUserEmail.html",
	},
	"JPEC": {
		name: "JPEC",
		title: "JPEC IdeaStorm",
		hosts: ["jpec.steminnovator.com"],
		css: `
			.btn-login {
				background-color: rgb(255, 205, 0);
				color: rgb(40,30,30);
			}
			.text-overlay {
				background-color: rgb(40,30,30,0.75);
				max-width: 800px;
				display: inline-block;
				padding: 10px;
				top: 60%;
				left: 10%;
			}
			.text-overlay-header {
				color: rgb(255, 205, 0);
			}
			.home-img {
				height: 1000px;
			}`,
		header_logo: require("@/assets/images/John-Pappajohn-Entrepreneurial-Center-LockupHorizontal-BLACK.png"),
		login_bg: require("@/assets/images/Staff-Grad-Faculty Winners.jpg"),
		home_promo: false,
		home_title: "Iowa Innovation Challenge",
		home_text: "The Iowa Innovation Challenge is a university-wide competition with the goal to identify, advance and support the most innovative and entrepreneurial projects on campus.",
		template: "src/template/inviteUserEmailJPEC.html",
		main_page_color: "yellow",
	}
};

var defaultBrand = brands["STEM Innovator"];

export default {
	currentTheme: null,

	getHost() {
		return window.location.host;
	},

	load() {
		this.loadCSS(this.getBrand());
	},

	getBrand() {
		let host = this.getHost();
		var brand = null;
		for (const key in brands) {
			if (brands[key].hosts.includes(host)) {
				brand = brands[key];
			}
		}

		if (brand) {
			return brand;
		} else {
			console.log("No brand found for host", host, ", using default");
			return defaultBrand;
		}
	},

	loadCSS(brand) {
		var styleElement = document.getElementById("brand-css");
		if (!styleElement) {
			var head =
				document.head || document.getElementsByTagName("head")[0];
			styleElement = document.createElement("style");
			styleElement.id = "brand-css";
			styleElement.type = "text/css";
			head.appendChild(styleElement);
		}

		var existingTextNode = styleElement.childNodes[0];
		if (existingTextNode) {
			styleElement.replaceChild(
				document.createTextNode(brand.css),
				existingTextNode
			);
		} else {
			styleElement.appendChild(document.createTextNode(brand.css));
		}
	},

	setTitle(brand) {
		console.log("Set title", brand.title);
		document.title = brand.title;
	}
};